"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$tocHeadLine = void 0;
const factory_1 = __importDefault(require("../factory"));
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const inline_1 = require("../../../node/cst/inline");
const _sentenceChildren_1 = require("./$sentenceChildren");
/**
 * The parser rule for {@link TOCHeadLine} that represents a head line of a TOC (Table Of Contents). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$tocHeadLine.spec.ts) for examples.
 */
exports.$tocHeadLine = factory_1.default
    .withName("tocHeadLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .and(r => r.regExp(/^:toc:/), "value")
    .action(({ value, range }) => ({ value, range: range() }))), "control")
    .and(r => r
    .sequence(s => s
    .and(() => lexical_1.$_, "value")
    .action(({ value, range }) => ({ value, range: range() }))), "trailingSpace")
    .action(({ control, trailingSpace }) => {
    return new inline_1.Control(control.value, control.range, trailingSpace.value, trailingSpace.range);
}))), "control")
    .and(r => r
    .assert(({ indentsStruct, control }) => {
    return (control !== null) || (indentsStruct.value.indentTexts.length === 0);
}))
    .and(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    // eslint-disable-next-line no-irregular-whitespace
    .or(r => r.regExp(/^目[ 　\t]*次/))
    .orSequence(s => s
    .andOmit(r => r
    .assert(({ control }) => control))
    .and(r => r
    .asSlice(r => r
    .choice(c => c
    .or(() => _sentenceChildren_1.$sentenceChildrenWithoutToplevelInlineToken)
    .or(r => r.nextIs(() => lexical_1.$_EOL))))))), "label")
    .action(({ label }) => {
    return {
        contentText: label,
    };
})), "contentStruct")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, indentsStruct, control, contentStruct, lineEndText }) => {
    const errors = indentsStruct.errors;
    return {
        value: new line_1.TOCHeadLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            title: contentStruct.contentText,
            controls: control ? [control] : [],
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$tocHeadLine;
//# sourceMappingURL=$tocHeadLine.js.map